/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonEmployeePostsDropdown200,
  GetApiV1PersonEmployeePostsDropdown401,
  GetApiV1PersonEmployeePostsDropdown500,
  GetApiV1PersonEmployeePostsDropdownQueryParams,
  GetApiV1PersonEmployeePostsDropdownQueryResponse,
} from "../../types/personEmployeeController/GetApiV1PersonEmployeePostsDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1PersonEmployeePostsDropdownQueryParamsSchema = z
  .object({
    companyId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1PersonEmployeePostsDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonEmployeePostsDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1PersonEmployeePostsDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonEmployeePostsDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonEmployeePostsDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonEmployeePostsDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonEmployeePostsDropdown500>;

export const getApiV1PersonEmployeePostsDropdownQueryResponseSchema = z.lazy(
  () => getApiV1PersonEmployeePostsDropdown200Schema,
) as unknown as ToZod<GetApiV1PersonEmployeePostsDropdownQueryResponse>;
